import React from "react";
import styled, { css } from "styled-components";
import { Family } from "../api/models/fullProductData.models";
import { ReportStatus } from "../api/models/report.models";

type TypeTagProps = {
  type: ReportStatus | null;
  children: React.ReactNode;
};

const StyledTag = styled.span<{ $type: ReportStatus | null }>`
  width: 145px;
  text-align: center;
  border: 2px solid var(--sumi-dark-blue);
  border-radius: 4px;
  padding: 2px 0;
  font-weight: 500;
  font-size: 14px;
  display: inline-block;
  box-sizing: border-box;
  max-height: 48px;
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
  white-space: nowrap;

  ${({ $type }) => {
    switch ($type) {
      case ReportStatus.Draft:
        return css`
          background: none;
          color: #143a6d;
        `;
      case ReportStatus.Sent:
        return css`
          border: 2px solid var(--sumi-light-green);
        `;
      case ReportStatus.WaitingForApproval:
        return css`
          background: var(--sumi-light-yellow);
          border: 2px solid var(--sumi-light-green);
          color: var(--sumi-yellow);
        `;
      default:
        return css`
          background: var(--sumi-light-blue);
          border: 2px solid var(--sumi-light-blue);
          color: var(--sumi-blue);
        `;
    }
  }}
`;

export const StatusTag: React.FC<TypeTagProps> = ({ type, children }) => (
  <StyledTag $type={type}>{children}</StyledTag>
);
